/**
 * const.js(設定値管理)
 */
'use strict';

let Const = require('../../server/config/const');
const value = Const.value;

// -------------------------------------------------------

export default {
  value,
};